/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vcG1zL2N1c3RvbWVyL2FjY291bnQvYWNjb3VudC1kZXRhaWxzL3VwZGF0ZS1hY2NvdW50L3VwZGF0ZS1hY2NvdW50LmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
